<template>
  <div>
    <div class="p-ml-3 p-mb-0" v-if="company">
      <h1 class="p-mb-0">{{ company.companyname  }}</h1>
      <p class="subHeader">Bedrift</p>
    </div>
    <TabView class="p-pt-5">
      <TabPanel header="Prosjekter">
        <projects />
      </TabPanel>
      <TabPanel header="Ansatte">
        <employeesList :baseEmployees="employees" @remove="removeEmployee"  />
        <employeeAdd  @add="addEmployees"/>
      </TabPanel>
      <TabPanel header="Profil">
        <companyEdit />
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import companyEdit from '@/components/companies/companyEdit'
import projects from '@/components/projects/projects'
import employeesList from '@/components/employees/employeesList'
import employeeAdd from '@/components/employees/employeeAdd'

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
export default {
name: 'companyDetails',

components:{
  TabView,
  TabPanel,
  companyEdit,
  projects,
  employeesList,
  employeeAdd
},

mounted(){
  if(typeof this.$route.params?.id !== 'undefined'){
    this.$store.dispatch('companies/inspect', this.$route.params.id).then((company) => {
      this.$store.dispatch('employees/inspect', {id: company.organizationnumber, type: 'company'}).then(() => {
        this.$store.dispatch('projects/inspect', {id: company.organizationnumber, type: 'company'})
      })
    })
    
    
  }
},

methods: {
  removeEmployee(employee){
    
    const index = employee.worksatcompany.indexOf(this.company.organizationnumber);
    
    if (index > -1) {
      employee.worksatcompany.splice(index, 1);
    }
    
    this.$store.dispatch('employees/update', employee)
  },
  
  addEmployees(user){
    user.forEach(user => {
      if(!user.worksatcompany.includes(this.company.organizationnumber)){
        user.worksatcompany.push(this.company.organizationnumber)
        this.$store.dispatch('employees/update', user)
      }
    })
  }
},

computed: {
  company(){ 
    return this.$store.getters["companies/inspect"]
  },

  employees(){
    return this.$store.getters["employees/inspect"]
  },

  projects(){
    return this.$store.getters["projects/inspect"]
  }
}


}
</script>